import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-panel" }
const _hoisted_2 = { class: "page-container" }
const _hoisted_3 = { class: "step-card" }
const _hoisted_4 = { class: "step-header" }
const _hoisted_5 = {
  key: 0,
  class: "step-summary"
}
const _hoisted_6 = { class: "step-body" }
const _hoisted_7 = { class: "competition-checkbox-list" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "empty-hint"
}
const _hoisted_10 = { class: "content-card" }
const _hoisted_11 = { class: "content-card-body" }
const _hoisted_12 = { class: "input-row" }
const _hoisted_13 = { class: "field-group" }
const _hoisted_14 = { class: "field-group" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 0,
  class: "results-card"
}
const _hoisted_18 = { class: "results-header" }
const _hoisted_19 = {
  key: 0,
  class: "results-count"
}
const _hoisted_20 = {
  key: 0,
  class: "loading-row",
  style: {"padding":"0.85rem 1rem"}
}
const _hoisted_21 = {
  key: 1,
  class: "table-wrap"
}
const _hoisted_22 = { class: "data-table" }
const _hoisted_23 = { class: "ticket" }
const _hoisted_24 = { class: "user-id" }
const _hoisted_25 = { class: "col-action" }
const _hoisted_26 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderDots = _resolveComponent("LoaderDots")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "page-header" }, [
        _createElementVNode("h1", { class: "page-title" }, "Select A Bonus Winner"),
        _createElementVNode("p", { class: "page-subtitle" }, "Pool entries from one or more competitions and run a bonus prize draw.")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "step-badge" }, "1", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "step-label" }, "Select competitions", -1)),
          (_ctx.selectedCompetitionIds.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.selectedCompetitionIds.length) + " selected ", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeCompetitions, (competition) => {
              return (_openBlock(), _createElementBlock("label", {
                key: competition.competitionId,
                class: "competition-checkbox-item"
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  value: competition.competitionId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCompetitionIds) = $event))
                }, null, 8, _hoisted_8), [
                  [_vModelCheckbox, _ctx.selectedCompetitionIds]
                ]),
                _createTextVNode(" " + _toDisplayString(competition.competitionTitle) + " (WSP" + _toDisplayString(competition.competitionId) + ") ", 1)
              ]))
            }), 128)),
            (!_ctx.activeCompetitions.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, "No active competitions found."))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "content-card-header" }, [
          _createElementVNode("span", { class: "card-title" }, "Draw Settings")
        ], -1)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[6] || (_cache[6] = _createElementVNode("label", {
                class: "field-label",
                for: "prize"
              }, "Prize", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "prize",
                type: "text",
                class: "field-input",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.prize) = $event)),
                placeholder: "e.g. BonusTV"
              }, null, 512), [
                [_vModelText, _ctx.prize]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[7] || (_cache[7] = _createElementVNode("label", {
                class: "field-label",
                for: "cutoff"
              }, "Entry Cut-off Date & Time", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "cutoff",
                type: "datetime-local",
                class: "field-input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cutOffDateTime) = $event))
              }, null, 512), [
                [_vModelText, _ctx.cutOffDateTime]
              ])
            ]),
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selectBonusWinner && _ctx.selectBonusWinner(...args))),
              disabled: _ctx.isSubmitting
            }, [
              (!_ctx.isSubmitting)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Select Bonus Winner"))
                : _createCommentVNode("", true),
              (_ctx.isSubmitting)
                ? (_openBlock(), _createBlock(_component_LoaderDots, { key: 1 }))
                : _createCommentVNode("", true)
            ], 8, _hoisted_15)
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "empty-hint" }, "Letters and numbers only for the prize name. Only entries submitted on or before the cut-off will be included in the draw.", -1))
        ])
      ]),
      (_ctx.loadingWinner || _ctx.bonusWinnerDetailsList.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "results-title" }, "Draw Results", -1)),
              (_ctx.bonusWinnerDetailsList.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.bonusWinnerDetailsList.length), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.loadingWinner)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[11] || (_cache[11] = [
                  _createElementVNode("span", { class: "loading-spinner" }, null, -1),
                  _createTextVNode(" Running bonus draw... ")
                ])))
              : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("table", _hoisted_22, [
                    _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Prize"),
                        _createElementVNode("th", null, "Competition Id"),
                        _createElementVNode("th", null, "Tickets Entered"),
                        _createElementVNode("th", null, "Winning Ticket"),
                        _createElementVNode("th", null, "Winning User Id"),
                        _createElementVNode("th", { class: "col-action" })
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bonusWinnerDetailsList, (winner, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(winner.prize), 1),
                          _createElementVNode("td", null, _toDisplayString(winner.competitionId), 1),
                          _createElementVNode("td", null, _toDisplayString(winner.numberOfTicketsEntered), 1),
                          _createElementVNode("td", _hoisted_23, _toDisplayString(winner.winningTicket), 1),
                          _createElementVNode("td", _hoisted_24, _toDisplayString(winner.userId), 1),
                          _createElementVNode("td", _hoisted_25, [
                            _createElementVNode("a", {
                              target: "_blank",
                              class: "btn-view-user",
                              href: `/users/${winner.userId}`,
                              title: "See winner details"
                            }, "→", 8, _hoisted_26)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}